// A template's page: fetch the template, hand it to TemplatePage, which owns
// the form, its cards and the save bar.

import { createFileRoute } from "@tanstack/react-router";
import { useTemplates } from "@/api/templates";
import { PageError, PageLoading, PageMessage, useRetry } from "@/components/page-states";
import { TemplatePage } from "@/features/templates/template-page";

export const Route = createFileRoute("/w/$workspaceId/templates/$templateId")({
    // Param-only navigation (one template's page straight to another's, as
    // Duplicate does) must remount, or the form keeps its previous defaultValues
    // and the new template's fields never appear: react-hook-form's
    // useForm only reads defaultValues once, on mount.
    remountDeps: ({ params }) => params,
    component: TemplateRoute,
});

function TemplateRoute() {
    const { workspaceId, templateId } = Route.useParams();
    const templatesQuery = useTemplates(workspaceId);
    const templatesRetry = useRetry(templatesQuery);

    if (templatesRetry.failed) return <PageError level={1} {...templatesRetry.props} />;
    if (templatesQuery.isLoading) return <PageLoading />;
    const template = templatesQuery.data?.find((t) => t.id === templateId);
    if (!template) {
        return <PageMessage level={1} title="Template not found" message="It doesn't exist, or was deleted." />;
    }

    return <TemplatePage template={template} />;
}
